document.addEventListener('alpine:init', () => {


    Alpine.data('admin_episodes_index_x_data', () => ({
        delete_episode_modal: false,
        show_title: '',
        episode_title: '',
        show_id: '',
        episode_id: '',
        delete_url: '',
        episode_errors: false,
        error_details: '',
        delete_episode_loading: false,
        handle_delete_episode() {
            this.delete_episode_loading = true
            let account_password = this.$refs.password.value
            let passphrase = this.$refs.passphrase.value

            console.log("account_password", account_password)
            console.log("passphrase", passphrase)

            fetch(this.delete_url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                body: JSON.stringify({
                    account_password: account_password,
                    passphrase: passphrase
                })
            }).then(response => {
                if (response.ok) {
                    window.location.reload()
                } else {
                    response.json().then(data => {
                        console.log("error", data)
                        this.episode_errors = true
                        this.error_details = data.error
                        this.delete_episode_loading = false
                    })
                }
            })

        },
        handle_episode_modal(event) {
            this.delete_episode_modal = true
            // Get the data from the dataset of the parent element
            this.show_title = event.target.dataset.showTitle
            this.episode_title = event.target.dataset.episodeTitle
            this.show_id = event.target.dataset.showId
            this.episode_id = event.target.dataset.episodeId
            this.delete_url = event.target.dataset.deleteUrl
        },
        remove_error_alert() {
            this.episode_errors = false
            this.error_details = ''
        }
    }));
});